

 <div class="w-full md:px-[3.5rem]">   
    <div class="container mx-auto mt-16  px-4 md:px-0">

        @if(itemsTotal())
        {
        <h1 class="font-dm-sans text-[var(--dark-teal)] text-2xl md:text-3xl mb-4">{{itemsTotal()}} results for “{{query}}”
        </h1>

        <app-custom-breadcrumb [isColorLight]="true" [separatorIsChevron]="true"></app-custom-breadcrumb>

        }

        <div class="flex justify-between mt-10">

            <div class="flex mb-4 lg:mb-8">
                <p-select [options]="sortFilters" [(ngModel)]="selectedSortSignal" placeholder="Sort by"
                    (onChange)="onSortChange($event)" class="text-xs w-full h-[35px] md:w-[300px]">
                </p-select>
            </div>


            <div class=" hidden md:block md:ml-auto">
                <p-selectbutton [options]="this.ItemListOptions" [(ngModel)]="viewMode" optionLabel="label"
                    optionValue="value" allowEmpty="false" class="custom-p-selectbutton h-[37px] border-none  md:ml-auto">
                    <ng-template #item let-item class="">
                        <p-button  [text]="item.value!=viewMode" class="custom-p-button">
                            <fa-icon class="text-[12px]"
                                [icon]="item.value == 'image' ? icons.faImage : icons.faList"></fa-icon>
                            <span class="whitespace-nowrap text-[12px]">{{item.label}}</span>
                        </p-button>
                    </ng-template>
                </p-selectbutton>
            </div>
        </div>

        @if(query){
        <p class="text-[var(--charcoal)]  md:text-xl mt-3 md:mt-0">Want to stay updated? Create a <span
                class="text-[#007BC2] font-bold cursor-pointer" (click)="toggleSaveSearch(query)">Saved
                Search</span> to get updates when matching items are added or close to ending.</p>

        }
    </div>    
</div>


@if(viewMode === 'image')
{
<app-item-vertical-template [items]="items()" (favoriteStatus)="onFavoriteChanged($event)"></app-item-vertical-template>
}
@else{
<app-item-horizontal-template [items]="items()" (favoriteStatus)="onFavoriteChanged($event)">
</app-item-horizontal-template>

}

<p-paginator [rows]="per()" [first]="first()" [totalRecords]="itemsTotal()" [rowsPerPageOptions]="rowsPerPageOptions"
    (onPageChange)="onPageChange($event)" styleClass="mt-7 text-sm">
</p-paginator>